<template>
  <li>
    <div class="flex items-center">
      <i
        v-if="divider"
        class="fa-sharp fa-regular fa-fw fa-chevron-right shrink-0 text-neutral-400 dark:text-neutral-600 text-xs mr-2"
        aria-hidden="true"></i>
      <RouterLink
        :to="path"
        class="text-sm font-medium text-neutral-500 dark:text-neutral-400 hover:text-neutral-700 dark:hover:text-neutral-300">
        {{ label }}
      </RouterLink>
    </div>
  </li>
</template>

<script>
import { RouterLink } from 'vue-router'

export default {
  components: { RouterLink },
  props: {
    label: {
      type: String,
      required: true
    },
    path: {
      type: [String, Object],
      required: true
    },
    divider: {
      type: Boolean,
      default: false
    }
  }
}
</script>
